export function AutoUnsubscribe(subKey = 'subscriptions'): ClassDecorator {
  return function (constructor) {
    const original = constructor.prototype.ngOnDestroy;

    constructor.prototype.ngOnDestroy = function () {
      const property = this[subKey];

      if (property && typeof property.unsubscribe === 'function') {
        property?.unsubscribe();
      }

      if (original && typeof original === 'function') {
        original.apply(this);
      }
    };
  };
}
